import { gql } from '@apollo/client';

export const OutreachActivityQuery = gql`
  query OutreachActivity($since: DateTime) {
    outreachActivity(since: $since) {
      id
      companyId
      companyName
      campaignId
      kind
      refType
      refId
      schedulerFlowId
      proposalId
      actorUserSub
      actorName
      recipientRole
      body
      createdAt
    }
  }
`;
